export class ConstMap<T, K> extends Map<T, K> {
  private map: Map<T, K>;

  constructor(map: Map<T, K> | [T, K][]) {
    super(map);
    this.map = new Map<T, K>(map);
  }

  get(key: T): K {
    const value = this.map.get(key);
    if (!value) {
      console.error(`ConstMap: Value not found for key: ${key}`);
      return undefined as K;
    }
    return value;
  }

  toArray(): { key: T; value: K }[] {
    return Array.from(this.map.entries()).map(([key, value]) => ({
      key: key,
      value: value,
    }));
  }
}
